import {Component} from "react";
import React from "react";
import styled from 'styled-components'
import {Container, Row, Col} from 'styled-bootstrap-grid';
import PropTypes from "prop-types";
import {media} from 'styled-bootstrap-grid';
import {connect} from "react-redux";
import Text from "../atoms/Text";


const Caption = styled.h1`
  text-transform: lowercase;
  ${media.lg`
     float: ${(props) => props.sideCaption ? 'right' : 'left'};
     text-align: ${(props) => props.sideCaption ? 'right' : 'left'};
  `}
`;

const RowS = styled(Row)`
  padding-left: 15px !important;
  padding-right: 15px !important;
  ${media.lg`
  padding-left: calc(var(--pad, 1px) / 2) !important;
  padding-right: calc(var(--pad, 1px) / 2) !important;
        
  `}
`;

const PaddedContainer = styled(Container)`
  padding-bottom: ${(props) => props.halfPadding ? 'calc(var(--pad, 1px) / 2)' : "var(--pad)"};
  padding-top: ${props => props.hasTopPadding ? (props.halfPadding ? 'calc(var(--pad, 1px) / 2)' : "var(--pad)") : "0px"};
  ${media.lg`
    max-width: 960px !important;
  `}
`;


class TextBlock extends Component {

    render() {

        return (
            <PaddedContainer hasTopPadding={this.props.hasTopPadding} halfPadding={this.props.halfPadding}>
                {this.props.noCaption ?
                    <Row justifyContent={"center"}>
                        <Col col={12} lg={10}>
                            <Text blockText={this.props.blockText} darkText={this.props.darkText}
                                  centeredText={this.props.centeredText}>
                                {this.props.children}
                            </Text>
                        </Col>
                    </Row>
                    :
                    (this.props.sideCaption ?
                            <Row>
                                <Col col={12} lg={1}>
                                    <Caption sideCaption={this.props.sideCaption}>
                                        {this.props.device.isMobile ? this.props.captionMobile : this.props.caption}
                                    </Caption>
                                </Col>
                                <Col col={12} lg={10}>
                                    <Text blockText={this.props.blockText} darkText={this.props.darkText}
                                          centeredText={this.props.centeredText}>
                                        {this.props.children}
                                    </Text>
                                </Col>
                            </Row>
                            :
                            <Row justifyContent={"center"}>
                                <Col col={12} lg={11}>
                                    <Caption>
                                        {this.props.captionMobile}
                                    </Caption>
                                </Col>
                                <Col col={12} lg={11}>
                                    <Text blockText={this.props.blockText} darkText={this.props.darkText}
                                          centeredText={this.props.centeredText}>
                                        {this.props.children}
                                    </Text>
                                </Col>
                            </Row>
                    )
                }
            </PaddedContainer>
        );
    }
}


TextBlock.propTypes = {
    caption: PropTypes.object,
    captionMobile: PropTypes.object,
    noCaption: PropTypes.bool,
    blockText: PropTypes.bool,
    hasTopPadding: PropTypes.bool,
    halfPadding: PropTypes.bool,
    darkText: PropTypes.bool,
    centeredText: PropTypes.bool,
    sideCaption: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    device: state.device
});


export default TextBlock = connect(mapStateToProps)(TextBlock);